import styled from 'styled-components';

export const Container = styled.div`
	margin: 0 40px;

	@media (max-width: 600px) {
		margin: 0 15px;
	}
`;

export const ServicesContent = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-gap: 20px;

	@media (max-width: 1150px) {
		margin-left: -15px;
		margin-right: -15px;
		padding: 0 15px;
		overflow-x: scroll;
	}
`;

export const ServicesItem = styled.div`
	background: #ffffff;

	border: 2px solid #f0f1f4;
	box-sizing: border-box;
	border-radius: 4px;
	padding: 16px;
	margin-bottom: 3px;
	min-width: 200px;

	@media (max-width: 600px) {
		padding: 24px 16px;
		margin-bottom: 0;
		min-width: 252px;
	}
`;

export const ServicesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const TopWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-bottom: 24px;
	${({ theme }) => theme.typography.textXS};
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.primaryBlackColor};
	margin-bottom: 16px;
	flex: 1 1 100%;
`;

export const ServicesTitle = styled.div`
	${({ theme }) => theme.typography.textBoldL};
	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textBoldL};
	}
`;

export const ServicesPrice = styled.div`
	margin-top: auto;
	justify-self: flex-end;
	${({ theme }) => theme.typography.textXL};
`;
